export default __webpack_public_path__ + "static/media/si.e3a3f13c.svg";